import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { optimizeImg, buildSrcSet } from './utils/img';
// ============================================================
// META PIXEL — landing-side only (PageView + ViewContent).
// AddToCart / InitiateCheckout / Purchase are intentionally NOT fired here;
// those fire on Shopify (checkout) and the Thank You page (Purchase).
// Runs once at module execution → no duplicate events.
// ============================================================
const META_PIXEL_ID = '2108832803405292';
(function initMetaPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const w = window as any;
  if (w.__metaPixelInit) return; // idempotent guard against double-init
  w.__metaPixelInit = true;
  // Speed up the pixel script connection.
  const pc = document.createElement('link');
  pc.rel = 'preconnect';
  pc.href = 'https://connect.facebook.net';
  pc.crossOrigin = 'anonymous';
  document.head.appendChild(pc);
  // Official Meta Pixel base code (makes window.fbq a real function).
  /* eslint-disable */
  !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  const fbq = (window as any).fbq;
  fbq('init', META_PIXEL_ID);
  fbq('track', 'PageView');
  fbq('track', 'ViewContent', {
    content_name: 'Más de 300 Remedios Naturales de la Abuela',
    content_category: 'Biblioteca de Bienestar Natural',
    content_type: 'product',
    value: 299.99,
    currency: 'MXN'
  });
})();
// Same families/weights as before — loaded non-blocking instead of via a
// render-blocking @import inside the CSS bundle.
const FONTS_CSS_URL = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400;1,9..144,500&family=Inter:wght@400;500;600;700&display=swap';
(function loadFonts() {
  if (typeof document === 'undefined') return;
  // Preconnect to the font origins to shorten the critical request chain.
  const gapi = document.createElement('link');
  gapi.rel = 'preconnect';
  gapi.href = 'https://fonts.googleapis.com';
  document.head.appendChild(gapi);
  const gstatic = document.createElement('link');
  gstatic.rel = 'preconnect';
  gstatic.href = 'https://fonts.gstatic.com';
  gstatic.crossOrigin = 'anonymous';
  document.head.appendChild(gstatic);
  // Preload the primary font CSS as a style resource (high-priority, non-blocking).
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'style';
  preload.href = FONTS_CSS_URL;
  document.head.appendChild(preload);
  // Load the stylesheet without blocking render: attach as print media, then
  // promote to all once it has loaded. Text paints immediately with the
  // system fallback and swaps to the web font when ready (display=swap).
  const sheet = document.createElement('link');
  sheet.rel = 'stylesheet';
  sheet.href = FONTS_CSS_URL;
  sheet.media = 'print';
  sheet.onload = () => {
    sheet.media = 'all';
  };
  document.head.appendChild(sheet);
})();
// Preload ONLY the hero image so the LCP element starts downloading as early
// as possible. Uses a responsive preload so mobile fetches the small,
// crisp candidate — matching the Hero <img> srcset/sizes exactly.
const HERO_SRC = 'https://cdn.magicpatterns.com/uploads/mn2tVderiXGBBJZpuSjciP/remedios_hero_optimizada_1200.webp';
const HERO_FALLBACK = optimizeImg(HERO_SRC, {
  w: 672,
  q: 72,
  dpr: 1
});
const HERO_SRCSET = buildSrcSet(HERO_SRC, [360, 540, 720, 900, 1200], 72);
const HERO_SIZES = '(max-width: 768px) 92vw, 672px';
(function preloadHero() {
  if (typeof document === 'undefined') return;
  // Warm up the CDN connection ahead of the image request.
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://cdn.magicpatterns.com';
  preconnect.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect);
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = HERO_FALLBACK;
  preload.setAttribute('imagesrcset', HERO_SRCSET);
  preload.setAttribute('imagesizes', HERO_SIZES);
  preload.setAttribute('fetchpriority', 'high');
  document.head.appendChild(preload);
})();
render(<App data-id="element-346" />, document.getElementById('root'));